export default [
    {
        "src": require("../assets/images/walzprofile.jpg"),
        "titles": {
            "fr": ["Laminés à chaud"],
            "en": ["Hot rolled"]
        },
        "manufacturers": [
            /*{
                "href": "/specialprofiles/hotrolled/hoesch",
                "name": "Hoesch"
            },*/
            {
                "href": "/specialprofiles/hotrolled/falci",
                "name": "Falci"
            },
            /*{
                "href": "/specialprofiles/hotrolled/vuhz",
                "name": "Vuhz"
            }*/
        ]
    },
    {
        "src": require("../assets/images/warmstrangpresse.jpg"),
        "titles": {
            "fr": ["Extrudés à chaud"],
            "en": ["Hot extruded"]
        },
        "manufacturers": [
            {
                "href": "/specialprofiles/hotextruded/siderval",
                "name": "Siderval"
            },
            {
                "href": "/specialprofiles/hotextruded/hsep",
                "name": "HSEP"
            },
        ]
    },
    {
        "src": require("../assets/images/ziehbankh.jpg"),
        "titles": {
            "fr": ["Etirés à froid"],
            "en": ["Cold drawn"]
        },
        "manufacturers": [
            {
                "href": "/specialprofiles/colddrawn/calvi",
                "name": "Calvi"
            },
            {
                "href": "/specialprofiles/colddrawn/hoesch",
                "name": "Hoesch"
            },
        ]
    },
    {
        "src": require("../assets/images/soudelaser.jpg"),
        "titles": {
            "fr": ["Soudés laser"],
            "en": ["Laser welding"]
        },
        "manufacturers": [
            {
                "href": "/contact",
                "name": "Nous contacter / Contact us"
            },
        ]
    }
]